/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import textStyles from '../../foundations/textStyles'

const mapStatusColorScheme = (c) => {
    switch (c) {
        // info
        case 'blue':
            return 'stokkeCore.black'
        // warning
        case 'orange':
            return 'stokkeCore.black'
        // success
        case 'green':
            return 'stokkeFunctional.alertGreen'
        // error
        case 'red':
            return 'stokkeFunctional.alertRed'
        // custom color scheme
        default:
            return c
    }
}

const solidVariant = ({colorScheme: c}) => ({
    container: {
        bg: mapStatusColorScheme(c),
        color: 'stokkeCore.white'
    }
})

export default {
    baseStyle: {
        container: {
            px: 3,
            py: 3,
            ...textStyles['Regular Medium']
        },
        title: {
            marginEnd: 2.5
        }
    },
    variants: {
        solid: solidVariant,
        subtle: (props) => ({
            container: {
                borderColor: `${props.colorScheme || 'green'}.600`,
                borderWidth: 1,
                borderStyle: 'solid'
            }
        })
    },
    defaultProps: {
        variant: 'solid'
    }
}
